<span [ngStyle]="{'display' : isBigSizeIcon ? 'none' : 'block'}">
  <input multiple autocomplete="off" *ngIf="!isShowProgressBar && allowedFiles" type="file"
    [ngStyle]="{'top' : topPosition + 'px'}" id="{{Id ? Id : elementIds.file}}" accept="{{allowedFiles}}"
    (change)="handleFileInput($event)">
</span>
<button *ngIf="isBigSizeIcon && allowedFiles" [disabled]="isShowProgressBar" (click)="onAction(1)"
  class="button_icon button_icon_color" style="font-size: 75px !important;">file_upload</button>
<button *ngIf="!isBigSizeIcon && isShowProgressBar && allowedFiles" [ngStyle]="{'top' : topPosition + 'px'}"
  class="button_icon button_icon_color" [disabled]="true">file_upload</button>
<div *ngIf="isShowProgressBar" class="progress_section">
  <app-progress-bar [value]="progress"></app-progress-bar>
</div>